import { updateSelected, updateState } from '../../state';

import { cleanupMouse } from './cleanupMouse';
import { cleanupSelected } from './cleanupSelected';
import { mappedTraits } from './modes';

export function cleanup(state) {
  const { mols, mode, selected, mouse } = state;
  const molIndex = mouse.molIndex;

  state = updateState(state, {
    selected: updateSelected(selected, cleanupSelected(selected[molIndex], mols[molIndex]), molIndex),
  });
  state = updateState(state, { mouse: cleanupMouse(mouse, mols[molIndex]) });
  state = updateState(state, {
    mode: mappedTraits[mode.type].cleanup(mode, mols[molIndex]),
  });

  return state;
}
